import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBuilding03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.161 2h9.678c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V20h1a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h1V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C6.18 2 6.635 2 7.161 2Zm.089 4a1 1 0 0 0 0 2H10a1 1 0 1 0 0-2H7.25Zm0 4a1 1 0 1 0 0 2H10a1 1 0 1 0 0-2H7.25Zm-1 5a1 1 0 0 1 1-1H10a1 1 0 1 1 0 2H7.25a1 1 0 0 1-1-1ZM14 6a1 1 0 1 0 0 2h2.75a1 1 0 1 0 0-2H14Zm-1 5a1 1 0 0 1 1-1h2.75a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h2.75a1 1 0 1 0 0-2H14Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgBuilding03.displayName = 'Building03';
export default SvgBuilding03;
